import { z } from "zod";

export const devicePlatformSchema = z.enum(["ios", "android"]);

export const deviceTokenRegisterRequestSchema = z.object({
  platform: devicePlatformSchema,
  token: z.string().min(1).max(4096),
  deviceId: z.string().max(128).optional(),
  appVersion: z.string().max(32).optional(),
  locale: z.string().max(16).optional(),
});

export const deviceTokenRegisterResponseSchema = z.object({
  ok: z.literal(true),
});

// Optional body — when present, only that token is detached. When absent
// (DELETE without body), all tokens of the current user are detached
// (used on logout-all).
export const deviceTokenUnregisterRequestSchema = z
  .object({
    token: z.string().min(1).max(4096).optional(),
  })
  .optional();

export const deviceTokenUnregisterResponseSchema = z.object({
  removed: z.number().int().min(0),
});

export type DevicePlatform = z.infer<typeof devicePlatformSchema>;
export type DeviceTokenRegisterRequest = z.infer<
  typeof deviceTokenRegisterRequestSchema
>;
export type DeviceTokenUnregisterRequest = z.infer<
  typeof deviceTokenUnregisterRequestSchema
>;
